module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff2
// module id = 1570
// module chunks = 6